export default __webpack_public_path__ + "static/media/cambridge-campus-lg.b5bd3ba1.jpg";